import { Icon, IconButton, styled } from '../../../base';
import { ReactSVG } from 'react-svg';
import { TOP_HEADER_HEIGHT } from '../../../common';

export const HeaderContainer = styled('header')(({ theme }) => ({
    height: `${TOP_HEADER_HEIGHT}px`,
    width: '100%',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 0,
}));

export const StyledSVG = styled(ReactSVG)({
    height: '100%',
    width: 'auto',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    '& svg': {
        height: '100%',
        width: 'auto',
    },
});

export const BreadcrumbsWrapper = styled('div')(() => ({
    position: 'absolute',
    insetInlineStart: '16px',
}));

export const CompanyLogoWrapper = styled('div')(() => ({
    display: 'flex',
    marginInline: 'auto',
    position: 'absolute',
    right: 0,
    left: 0,
    width: 'fit-content',
}));

export const CompanyLogoImg = styled('img')(() => ({
    width: '120px',
    height: '60px',
    objectFit: 'contain',
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: theme.palette.background.mainBackground,
    marginInlineEnd: theme.spacing(1),
    height: '55px',
    width: '55px',

    '&:hover': {
        backgroundColor: theme.palette.grey[600],
    },
}));

export const StyledIcon = styled(Icon)(({ theme }) => ({
    color: theme.palette.secondary.main,
}));
